import { render, staticRenderFns } from "./AddPaymenTerm.vue?vue&type=template&id=3a9eb740&scoped=true&"
import script from "./AddPaymenTerm.vue?vue&type=script&lang=js&"
export * from "./AddPaymenTerm.vue?vue&type=script&lang=js&"
import style0 from "./AddPaymenTerm.vue?vue&type=style&index=0&id=3a9eb740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9eb740",
  null
  
)

component.options.__file = "AddPaymenTerm.vue"
export default component.exports